import React from 'react';
import { ITranslateTabProps } from './types';
import { alpha, Button, Menu, Stack, Tooltip } from '@mui/material';
import { theme } from '../../../../../../common/styles/theme';
import { SettingsIcon } from '../../../../../../../icons/SettingsIcon';
import { DeviceContext } from '../../../../../../common/contexts/DeviceContext';
import { Modal } from '../../../../../../common/components/Modal/Modal';
import { PhraseTranslationSettingsHOC } from '../../../PhraseDetailsTabsEditor/PhraseDetailsTabTranslation/PhraseTranslationSettings/hocs/PhraseTranslationSettingsHOC';
import { Text } from '../../../../../../common/components/Text/Text';
import { UserLangsTranslationColors } from '../../../PhraseDetailsTabsEditor/PhraseDetailsTabTranslation/helpers/userLangsTranslationColors';
import { LangUtil } from '../../../../../../common/utils/lang-util';
import { OneTimeTooltipSelectArrowHOC } from '../../../OneTimeTooltip/hocs/OneTimeTooltipSelectArrowHOC/OneTimeTooltipSelectArrowHOC';
import { ytElementId } from '../../../../../types/common';

export const TranslateTab: React.FC<ITranslateTabProps> = ({
	translateLangs,
}) => {
	const className = 'translate-tab';

	const {isMobile} = React.useContext(DeviceContext);

	const [settingsEl, setSettingsEl] = React.useState<null | HTMLElement>(null);
	const handleSettingsClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setSettingsEl(event.currentTarget);
	};
	const handleSettingsClose = () => {
		setSettingsEl(null);
	};

	const [videoHeight, setVideoHeight] = React.useState(0);
	React.useEffect(() => {
		let video;
		const setHeight = () => {
			video = document.getElementById(ytElementId);
			if (video) {
				const height = video.offsetHeight - 32;
				if (height) {
					setVideoHeight(height);
				}
			}
		}
		const setObserver = () => {
			video = document.getElementById(ytElementId);
			if (video) {
				setHeight();
				new ResizeObserver(setHeight).observe(video);
				if (interval) clearInterval(interval);
			}
		}
		let interval = setInterval(setObserver, 500);
	}, []);
		
	return (
		<Stack
			className={className}
			gap={3}
			sx={{
				p: theme.spacing(1, 2),
			}}
		>
			<Stack
				gap={1}
				sx={{
					minHeight: videoHeight,
				}}
			>
				<Text
					variant={'subtitle2'}
					sx={{
						fontWeight: 600,
					}}
				>
					Translation languages
				</Text>

				<Stack
					sx={{
					}}
				>
					{!!translateLangs?.length &&
						translateLangs.map((langCode, index) => {
							return (
								<Text
									noWrap
									variant={'subtitle2'}
									sx={{
										p: theme.spacing(0.25, 0),
										overflow: 'hidden',
										width: '100%',
										color: UserLangsTranslationColors.getColor(langCode),
									}}
									key={'lang' + langCode}
								>
									{LangUtil.getLangNameByCode(langCode)}
								</Text>
							);
						})
					}
				</Stack>
				
				<Tooltip
					title={'Translation settings'}
				>
					<Button
						onClick={handleSettingsClick}
						sx={{
							width: theme.spacing(3.5),
							height: theme.spacing(3.5),
							color: theme.palette.grey[400],
							
							'&:hover': {
								color: theme.palette.grey[700],
								background: alpha(theme.palette.grey[50], .5),
							},
					
							'.MuiSvgIcon-root': {
								width: theme.spacing(2),
								height: theme.spacing(2),
							},
						}}
					>
						<SettingsIcon />
					</Button>
				</Tooltip>

				{isMobile
					? <Modal
						onClose={handleSettingsClose}
						open={!!settingsEl}
						isMobile={isMobile}
						>
						<PhraseTranslationSettingsHOC />
					</Modal>
					: <Menu
						anchorEl={settingsEl}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'left',
						}}
						open={!!settingsEl}
						onClose={handleSettingsClose}
						sx={{
							'& .MuiPaper-root': {
								width: theme.spacing(35),
								mt: theme.spacing(1),
								boxShadow: theme.shadows[16],
							},
						}}
					>
						<PhraseTranslationSettingsHOC />
					</Menu>
				}
			</Stack>

			{!!videoHeight && <>
				{/* <OneTimeTooltipFullscreenHOC /> */}
				<OneTimeTooltipSelectArrowHOC />
			</>}
			
		</Stack>
	);

}
